import {useState, useEffect, useContext} from "react";
import {Switch, Route, useRouteMatch} from "react-router-dom";
import {langContext} from "commons/contexts";

import "./common.module.scss";

import FrontPage from "./FrontPage";
import SearchResults from "./SearchResults";
import NewsList from "./NewsList";

import Show from "./Show";
import ShowClients from "./Support/ShowClients";

import style from "./style.module.scss";

const text: {[key: string]: {[key: string]: string}} = {
    nl: {
        privacyText: `Deze website maakt gebruik van cookies om uw gebruikservaring te verbeteren. Door verder te surfen, stemt u in met ons cookie-beleid.`,
        privacyButton: `Meer info`
    },
    fr: {
        privacyText: `Ce site utilise des cookies pour améliorer votre expérience utilisateur. En poursuivant votre navigation, vous acceptez notre politique en matière de cookies.`,
        privacyButton: `En savoir plus`
    }
}

function NewSite() {
    const [properties, setProperties] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [hidePrivacyBox, setHidePrivacyBox] = useState(true);

    const {lang} = useContext(langContext);

    const {path} = useRouteMatch();

    useEffect(() => {
        if (!checkHidePrivacyBoxInCookie())
            setHidePrivacyBox(false);
    }, [])

    function checkHidePrivacyBoxInCookie() {
        let cookies = document.cookie.split(";");
        if (!(cookies[0])) return false;

        for (const cookie of cookies)
            if (cookie.indexOf("prvBox") >= 0)
                if (cookie.split("=")[1] === "true")
                    return true;

        return false;
    }

    function hidePrivacyBoxInCookie() {
        const cookies = document.cookie.split(";");
        if (cookies[0].length === 0) cookies.splice(0, 1);
        cookies.push("prvBox=true");

        document.cookie = cookies.join(";");
        setHidePrivacyBox(true);
    }

    return (
        <div className={style.enclose}>
            <Switch>
                <Route path="*/clients">
                    <ShowClients />
                </Route>
                <Route path={`${path}/news`}>
                    <NewsList />
                </Route>
                <Route path="*/results">
                    <SearchResults
                        propertiesState={{properties, setProperties}}
                        totalPagesState={{totalPages, setTotalPages}}
                    />
                </Route>
                <Route path="*/show">
                    <Show />
                </Route>
                <Route path="/">
                    <FrontPage />
                </Route>
            </Switch>

            {
                (!hidePrivacyBox) && <div className={style.privacyBox}>
                    <div className={style.content}>
                        <div>
                            {text[lang]?.privacyText || ""} <a href={`/${lang}/news/privacy-policy`}><b>{text[lang]?.privacyButton || ""}</b></a>
                        </div>
                        <input type="button" value="Ok" onClick={() => {
                            hidePrivacyBoxInCookie();
                        }} />
                    </div>
                </div>
            }
        </div>
    )
}

export default NewSite;